import Text from 'components/ui/Text';
import { formatPrice } from 'utils/formatPrice';

type ChargeAmountCellProps = {
    amount: number;
    canEdit?: boolean;
    currency?: string | null;
};

const ChargeAmountCell = ({ amount, canEdit, currency }: ChargeAmountCellProps) => {
    const formatted = formatPrice(amount, currency);

    return (
        <Text fontSize={13} color={canEdit ? 'text' : 'textDisabled'}>
            {formatted}
        </Text>
    );
};

export default ChargeAmountCell;
